export const UNIT_INVALID_SERIAL_NO_VALUES = ['0000']
